import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// Hook to parse query strings from the URL with a generic type for allowed params
var useQueryString = function useQueryString() {
  var _useLocation = useLocation(),
    search = _useLocation.search;

  // Memoize the parsing of the query string to avoid recalculations on re-renders
  return useMemo(function () {
    var params = new URLSearchParams(search);
    var queryObject = {};
    params.forEach(function (_, key) {
      queryObject[key] = decodeURIComponent(params.get(key));
    });
    return queryObject;
  }, [search]);
};
export default useQueryString;